/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable func-names */
/* eslint-disable func-style */

import { EventPayloadCrud, EventPayloadType } from '../controller-classes';

type PublishOptions = {
	useReturn?: boolean;
	useId?: boolean;
	useParentId?: boolean;
	payloadType?: EventPayloadType;
}

/**
 *  Accessor Decorator that publishes to subscribers the new value when the setter is called
 *
 * @param eventName Name of the event that will be published
 * @returns
 */
export function Publish (noun: string, action: string, options: PublishOptions = {}) {
	// console.log(`Publish Registering -> ${noun}:${action}`);
	return (_target: any, propertyKey: string, descriptor: PropertyDescriptor): void => {
		// console.log(`Publish Registered -> ${noun}:${action}`, { _target, propertyKey, descriptor })
		if (descriptor.value) {
			// method decorator
			const orig = descriptor.value;

			descriptor.value = function (...args) {
				const result = orig.call(this, ...args);

				// only publish after class has been initialized
				if (this.initialized) {
					const refId = options.useReturn ? (options.useId ? result.id : result) : this.id;
					const payload: EventPayloadCrud = {
						ref: options.useParentId ? this.parentId : refId,
						old: null,
						new: [...args]
					};

					// eslint-disable-next-line max-len
					// console.log(`Publish Method -> ${noun}:${action} (payload)`, { payload: JSON.stringify(payload), result: result !== false && result, obj: this, options, parentId: this.parentId });
					this.publish(noun, action, payload, options.payloadType);
				}
				return result;
			};
		} else if (descriptor.set) {
			// Accessor setter decorator
			const orig = descriptor.set;
			const getter = descriptor.get;
			descriptor.set = function (v: any) {
				const oldValue = getter ? getter.call(this) : null;
				orig.call(this, v);
				const newValue = getter ? getter.call(this) : null;

				// if there is a getter, check to see if value was updated, if not assume it was updated and default to true
				const valueChanged = getter ? oldValue !== newValue : true;

				if (this.initialized && valueChanged) {
					const payload: EventPayloadCrud = {
						ref: this.id,
						old: oldValue,
						new: v
					};
					// console.log(`Publish Setter -> ${noun}:${action} (payload)`, payload);
					this.publish(noun, action, payload, options.payloadType);
				}
			};
		}
	}
}
